import axios from "../../api/axiosConfig";
import * as Sentry from "@sentry/capacitor";

export async function magicTodo(message) {
    try {
        const response = await axios.post(`${import.meta.env.VITE_OPEN_AI_PROXY_URL}`, {
            apiKey: import.meta.env.VITE_OPEN_AI_PROXY_KEY,
            task: message
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        Sentry.captureException(error, {
            tags: {
                error_type: error.code === 'ECONNABORTED' ? 'ai_proxy_timeout' : 'ai_proxy_failure',
                operation: 'magicTodo',
            },
            level: 'error',
            extra: {
                status_code: error.response?.status,
                error_code: error.code,
            }
        });

        if (error.code === 'ECONNABORTED') {
            console.error("Error: Request timed out");
            return {
                success: false,
                message: "The request timed out. Please try again later.",
                status: 408 
            };
        }

        console.error("Error:", error.message);
        return {
            success: false,
            message: error.response?.data?.error || "Problem occurred while retrieving tasks. Please try again.",
            status: error.response?.status || 500
        };
    }
}
